/**
 * Typesets a rule as maths. Ported from the Ops Dashboard's `Formula`
 * (`src/modules/opsDashboard/components/Formula.tsx`) so the two pages state a calculation
 * the same way — Ops reads both, and a formula that looks different reads as a different
 * kind of claim.
 *
 * The notation is the same small LaTeX-ish subset:
 *
 *     frac{numerator}{denominator}    a stacked fraction
 *     anything else                   inline, in the maths face
 *
 * Hand-rolled rather than KaTeX or MathJax, for the reason the original gives: this renders
 * a handful of fractions and comparison operators, not a paper.
 */
export function Formula({ source }: { source: string }) {
  // Split on the fractions, keeping them: ["a = ", "frac{x}{y}", " × z"]
  const parts = source.split(/(frac\{[^{}]*\}\{[^{}]*\})/g).filter(Boolean)

  return (
    <span className="seg-formula">
      {parts.map((part, i) => {
        const frac = part.match(/^frac\{([^{}]*)\}\{([^{}]*)\}$/)
        if (!frac) return <span key={i}>{part}</span>
        return (
          <span key={i} className="seg-frac">
            <span className="seg-frac__num">{frac[1]}</span>
            <span className="seg-frac__den">{frac[2]}</span>
          </span>
        )
      })}
    </span>
  )
}
